import React from 'react';
import styles from './AcceptCookiesModal.css';

/***********************************************************************************************************************
 *
 * @type {React.NamedExoticComponent<{toggleCookies?: *, content?: *, closeCookiesModal?: *, button_style?: *, actionBtnClick?: *}>}
 ***********************************************************************************************************************/

const AcceptCookiesPopup = React.memo( ( { button_style, toggleCookies, actionBtnClick, closeCookiesModal, content } ) => (
    <div className={ styles.wrapper }>
        <div className={ styles.content }>
            <button className={ styles.closeButton } aria-label={ content.close_aria_label } onClick={ closeCookiesModal }>x</button>
            <span className={ styles.title }>{ content.oops_accept_cookies }</span>
            <span> { content.quiz_uses_cookies }
                {/*{ content.read_more } <a target='_blank' href='https://millionmind.com/terms/'>{ content.here }</a>*/}
            </span>
            <div className={ styles.buttonsGroup }>
                <button style={ button_style }
                    aria-label={ content.accept_and_play_aria_label }
                        onClick={ () => {
                            toggleCookies( true );
                            actionBtnClick();
                        } }
                >
                    { content.accept_and_play }
                </button>
            </div>
        </div>
    </div>
) );

export default AcceptCookiesPopup;